module.exports = __webpack_public_path__ + "assets/img/beds.af51c283.png";